import axios from "axios";
import { baseUrl } from "./baseUrl";
import { getPartnerToken } from "./auth";

const partnerApi = axios.create({
    baseURL: `${baseUrl}/partner`,
});

// Add auth token to requests
partnerApi.interceptors.request.use((config) => {
    const token = getPartnerToken();
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

// Get Partner Information/Settings
export const getPartnerSettings = async () => {
    try {
        const response = await partnerApi.get('/settings');
        return response.data.data;
    } catch (error) {
        console.error("Error fetching partner settings:", error);
        throw error;
    }
}

// Update Partner Settings
export const updatePartnerSettings = async (data) => {
    try {
        const response = await partnerApi.put('/settings', data);
        return response.data;
    } catch (error) {
        console.error("Error updating partner settings:", error);
        throw error;
    }
}

// Get Partner Documents
export const getPartnerDocuments = async () => {
    try {
        const response = await partnerApi.get('/documents/get-partner-documents');
        return response.data.data;
    } catch (error) {
        console.error("Error fetching partner documents:", error);
        throw error;
    }
}

// Upload Partner Document (Note: Backend route not implemented yet)
export const uploadPartnerDocument = async (formData) => {
    try {
        const response = await partnerApi.post('/documents/upload-document', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
        return response.data;
    } catch (error) {
        console.error("Error uploading partner document:", error);
        throw error;
    }
}

// Get Partner Notifications
export const getPartnerNotifications = async () => {
    try {
        const response = await partnerApi.get('/notifications');
        return response.data.data;
    } catch (error) {
        console.error("Error fetching partner notifications:", error);
        throw error;
    }
}

// Mark Notification as Read
export const markNotificationAsRead = async (notificationId) => {
    try {
        const response = await partnerApi.put(`/notifications/${notificationId}/read`);
        return response.data;
    } catch (error) {
        console.error("Error marking notification as read:", error);
        throw error;
    }
}

// Update Partner Profile
export const updatePartnerProfile = async (data) => {
    try {
        const response = await partnerApi.put('/settings/update-profile', data);
        return response.data;
    } catch (error) {
        console.error("Error updating partner profile:", error);
        throw error;
    }
}

// Change Partner Password
export const changePartnerPassword = async (data) => {
    try {
        const response = await partnerApi.put('/settings/change-password', data);
        return response.data;
    } catch (error) {
        console.error("Error changing partner password:", error);
        throw error;
    }
}

// Get Complete Partner Profile
export const getPartnerProfile = async (partnerId) => {
    try {
        const response = await partnerApi.get(`/auth/org-info/${partnerId}`);
        return response.data;
    } catch (error) {
        console.error("Error fetching partner profile:", error);
        throw error;
    }
}
